import { useContext, useEffect, useState, type ReactElement } from 'react'
import classnames from 'classnames'

import Header from '@/components/common/Header'
import css from './styles.module.css'
import SafeLoadingError from '../SafeLoadingError'
import SideDrawer from './SideDrawer'
import { useIsSidebarRoute } from '@/hooks/useIsSidebarRoute'
import { TxModalContext } from '@/components/tx-flow'
import BatchSidebar from '@/components/batch/BatchSidebar'
import { Inter, Londrina_Solid, Nunito, Press_Start_2P } from 'next/font/google'

const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-inter',
})

const londrina_solid = Londrina_Solid({
  weight: ['100', '300', '400', '900'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-londrina',
})

const nunito = Nunito({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-londrina-light',
})

const press_start_2p = Press_Start_2P({
  weight: '400',
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-press-start-2p',
})

const PageLayout = ({ pathname, children }: { pathname: string; children: ReactElement }): ReactElement => {
  const [isSidebarRoute, isAnimated] = useIsSidebarRoute(pathname)
  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(true)
  const [isBatchOpen, setBatchOpen] = useState<boolean>(false)
  const { setFullWidth } = useContext(TxModalContext)

  const hideHeaderRoutes = ['/game', '/game/board']

  useEffect(() => {
    setFullWidth(!isSidebarOpen)
    document.documentElement.classList.add(
      inter.variable,
      londrina_solid.variable,
      nunito.variable,
      press_start_2p.variable,
    )
  }, [isSidebarOpen, setFullWidth])

  return (
    <>
      {!hideHeaderRoutes.includes(pathname) && (
        <header className={css.header}>
          <Header onMenuToggle={isSidebarRoute ? setSidebarOpen : undefined} onBatchToggle={setBatchOpen} />
        </header>
      )}


      {isSidebarRoute && <SideDrawer isOpen={isSidebarOpen} onToggle={setSidebarOpen} />}

      <div
        className={classnames(css.main, {
          // [css.main]: !hideHeaderRoutes,
          [css.mainNoSidebar]: !isSidebarOpen || !isSidebarRoute,
          [css.mainAnimated]: isSidebarRoute && isAnimated,
        })}
      >
        <div className={css.content}>
          <SafeLoadingError>{children}</SafeLoadingError>
        </div>

        <BatchSidebar isOpen={isBatchOpen} onToggle={setBatchOpen} />
      </div>
    </>
  )
}

export default PageLayout
